import React from 'react';
import ReactDOM from 'react-dom';
import Due from './dues/due.js';
import Profile from './profile.js';
import SignUp from './signup.js';
import TopPanel from "./toppanel.js";
import Modal from './modal.js'
import ViewFeedback from "./viewfeedback.js"
import AboutUs from './about.js';

module.exports = React.createClass({

    getInitialState: function() {
        return {
            showSignUp: false,
            showAboutUs: false,
            showButtons: false
        }
    },

    componentDidMount: function() {
        this.setState({ showButtons: true });
    },

    handleLoginClicked: function() {
        var loginClass = React.createClass({
            successRequest: function (reply) {
                HC_SetLoginSettings(reply);
                HC_SendDeviceToken();
                this.state.isLoginClicked = false;

                //HC_CheckSubscription();

                HC_RestoreNavPanel();
                HC_GoDefaultPage();
                HC_CloseModal();
            },
            errorRequest: function (code, errorString) {
                if (code == 401) {
                    $("#login-error").html(HC_LANG.INDEX_INVALID_LOGIN);
                    $("#login-error").css({'display': 'block', 'color': '#d0021b'});
                    this.setState({isLoginClicked: false});
                }
                else
                    HC_SetError(code, errorString);
            },
            successResetPwdRequest: function (reply) {
                $("#email-error").html('Check your email to reset your password.');
                $("#email-error").addClass('hc-f3');
                $("#email-error").css({'display': 'block', 'color': '#30ae97', 'text-align': 'center'});

                $('#resetForm').find('.g-recaptcha').css('display', 'none');
                $('#resetForm').find('.hc-button').css('display', 'none');
                $("#resetPwdField").css('display','none');
            },
            errorResetPwdRequest: function (code, errorString) {
                grecaptcha.reset();
                if (code == 401) {
                    $("#email-error").html('No account matches ' + this.state.logindata.login);
                    $("#email-error").css({'display': 'block', 'color': '#d0021b'});
                }
                else
                    HC_SetError(code, errorString);
            },

            getInitialState: function() {
              return {
                  logindata: {},
                  isLoginClicked: false,
                  isForgotPwdClicked: false
              }
            },
            componentDidMount: function() {
                var login = ReactDOM.findDOMNode(this.refs.login);
                login.onkeypress = function(_this) { return function (e) {
                    e = e || window.event;
                    if (e.keyCode == 13 && !_this.state.isForgotPwdClicked)
                        ReactDOM.findDOMNode(_this.refs.password).focus();
                }}(this);
                var password = ReactDOM.findDOMNode(this.refs.password);
                password.onkeypress = function(_this) { return function (e) {
                    e = e || window.event;
                    if (e.keyCode == 13)
                        _this.handleLogined();
                }}(this);
                login.focus();
            },
            handleResetPwd: function() {
                if (HC_Validate()) {
                    var data = {email: this.state.logindata.login};
                    HC_SendRequest("forgot_password", data, this.successResetPwdRequest, this.errorResetPwdRequest);
                }
            },
            handleForgotPwd: function() {
                HC_InitReCaptcha();
                this.setState({isForgotPwdClicked: true});
                //$('resetForm').submit(false);
            },
            handleLogined: function() {
                if (this.state.isLoginClicked)
                    return;

                if (this.state.logindata.login == undefined || this.state.logindata.password == undefined) {
                    $("#login-error").html(HC_LANG.INDEX_LOGPASS_NOT_EMPTY);
                    $("#login-error").css({'display': 'block', 'color': '#d0021b'});
                    return;
                }
                else
                    $("#login-error").css({'display': 'none'});

                this.setState({isLoginClicked: true});
                const {login, password, code} = this.state.logindata;
                const payload = {login, password, code, is_free: window.HC_SITE_LOGO.isFree};
                HC_SendRequest("login", payload, this.successRequest, this.errorRequest);
            },

            textFieldChanged(o) {
                this.state.logindata[o.target.getAttribute('name')] = o.target.value;
                this.setState({logindata: this.state.logindata});
            },
            render: function () {
                let saStyle = {display: (this.state.logindata.login == "sa" && this.state.logindata.password != null) ? "block" : "none"};
                return (
                    <Modal data-style={{maxWidth: '30rem', width: '90%'}}>
                        <div className="hc-close-btn hc-f2 " style={{marginTop:"2%", marginRight:"2%"}} onClick={HC_CloseModal}>
                            <i style={{float: "right", marginBottom: "50%"}}  className="fa fa-times"/>
                        </div>
                        <div align="left" style={{padding: "5% 10% 6%"}}>
                            <p className="hc-f3">{this.state.isForgotPwdClicked ? "If you forgot you password, please enter email you used to register account" : HC_LANG.INDEX_LOGIN_BUTTON}</p>
                            {(this.state.isForgotPwdClicked ?
                                <form id="resetForm" action="/" noValidate >
                                    <div>
                                        <span id="email-error" style={{display: "none", marginBottom:'0.5rem', fontSize: "0.875rem !important",fontWeight: "normal"}} />
                                        <input id="resetPwdField" name="login" className="form-control hc-validated"
                                               type="email" style={{width:"100%"}}
                                               data-vfunc="HC_ValidateNotEmptyField" data-vtext="email-error"
                                               value={this.state.logindata.login} onChange={this.textFieldChanged}/>
                                    </div>

                                    <div className="g-recaptcha hc-validated" data-sitekey="6Lc0-gkUAAAAAEXhX7zT3so2-zWpERmwdU8b8Iko" data-vfunc="HC_ValidateCaptcha"></div>

                                    <div style={{paddingTop: "1rem", textAlign: "center"}}>
                                        <input className="hc-button" onClick={this.handleResetPwd} disabled value="Reset Password" style={{textAlign: "center"}}/>
                                    </div>
                                </form>
                                    :
                                <form id="loginForm" action="/" noValidate onSubmit={function(e){e.preventDefault();}}>
                                    <div>
                                        <span id="login-error"
                                              style={{display: "none", marginBottom:'0.5rem', fontSize: "0.875rem !important",fontWeight: "normal"}}/>
                                        <input id="loginField" ref="login" name="login" className="form-control "
                                               type="email" placeholder={HC_LANG.ADM_LOGIN} style={{width:"100%"}}
                                               value={this.state.logindata.login} onChange={this.textFieldChanged}/>
                                    </div>
                                    <div>
                                        <input ref="password" name="password" className="form-control " type="password"
                                               placeholder={HC_LANG.ADM_PWD} style={{width:"100%", marginTop:"3%"}}
                                               value={this.state.logindata.password} onChange={this.textFieldChanged}/>
                                    </div>

                                    <div style={saStyle}>
                                        <input ref="code" name="code" className="form-control " type="number"
                                               style={{width:"110px", marginTop:"3%"}}
                                               value={this.state.logindata.code} onChange={this.textFieldChanged}/>
                                    </div>

                                    <div style={{paddingTop: "1rem"}}>
                                        <input type="submit" data-role="none" className="hc-button"
                                               value={HC_LANG.INDEX_LOGIN_BUTTON} style={{marginRight: "4%"}}
                                               onClick={this.handleLogined}/>
                                    </div>
                                </form>
                            )}
                        </div>
                    </Modal>
                );
            }
        });
        HC_ShowModal(loginClass);
    },

    handleShowAboutUsClicked: function () {
        let shAbus = !this.state.showAboutUs;
        this.setState({showAboutUs: shAbus});
    },

    handleSignupClicked: function() {

        if (HC_DeviceType() == HC_CONST.SCR_DESCKTOP){

            var signupClass = React.createClass({

                render: function () {
                    return (
                        <Modal data-style={{maxWidth: '40rem', width: '100%'}}>

                                <div className="hc-close-btn hc-f2 " style={{marginTop:"2%", marginRight:"2%"}} onClick={HC_CloseModal}>
                                    <i style={{float: "right", marginBottom: "50%"}}  className="fa fa-times"/>
                                </div>
                                <div>
                                    <p className="hc-f3"
                                       style={{paddingLeft: "43%", paddingTop:"5%"}}>{HC_LANG.INDEX_SIGNUP_BUTTON}</p>
                                </div>
                                <SignUp OnBackClicked={HC_CloseModal} />
                        </Modal>
                    );
                }
            });
            HC_ShowModal(signupClass);
        }
        else {

            this.setState({
                showSignUp: true
            });
        }
    },

    OnBackClicked:function() {
        this.setState({
            showSignUp: false
        });
    },
    handleLanguageClicked: function (o) {
        this.setState({selectedLanguage: o.target.title});
        window.HC_ChangeLanguage(o.target.title);
    },

    render: function() {
        HC_RestoreNavPanel();

        if (window.HC_GetSession()) {
            if (HC_SA())
                return <ViewFeedback/>;
            if (!HC_IsSubscribed())
                return <Profile/>
            if (HC_AccInput())
                return <Due/>;
            return <Profile/>
        }
        var indexStyle = {width:"100%", height:"100%", overflowY:'auto', WebkitOverflowScrolling:'touch', overflowX:'hidden', textAlign: "center", whiteSpace: 'normal'};
        var i = 0;
        var languagesItem = window.HC_Languages.map(function (lang) {
            var flStyle = {backgroundImage: "url('public/images/" + lang + ".svg')", backgroundSize: 'cover'};
            var clName = "flag " + (window.HC_CURRENT_LANGUAGE === lang ? "flag-selected" : "");
            return (
                <input key={i++} type="button" className={clName} title={lang} style={flStyle} onClick={this.handleLanguageClicked}/>
            );
        }.bind(this));
        let loginBtnStyle = {padding:"2%", margin: "0 -20px 0 -20px", visibility: this.state.showButtons ? '' : 'hidden' };
        const isFreeSite = window.HC_SITE_LOGO.isFree;

        return (
            <div id="index-page" style={indexStyle}>

                {(this.state.showAboutUs ?
                    <AboutUs onBack={this.handleShowAboutUsClicked} locale={languagesItem}/>
                    :
                    (this.state.showSignUp ?
                        <div>
                            <TopPanel text="Sign Up" licon = "fa-angle-left" onLiconClick={this.OnBackClicked} liconText="Home" EnableMenuText={HC_DeviceType() !== HC_CONST.SCR_PHONE} />
                            <div style={{width:"5%"}}>&nbsp;</div>
                            <SignUp OnBackClicked={this.OnBackClicked} />
                        </div>
                        :
                        <div>
                            <div className="container" style={{maxWidth: "700px", marginBottom: "1em"}}>
                                <header>
                                    <div style={{paddingTop:"5%", paddingBottom:"2%", marginLeft: "-15px", marginRight: "-15px" }}>
                                        <img src={window.HC_SITE_LOGO.src} style={window.HC_SITE_LOGO.style} alt="logo" />
                                    </div>
                                    <div style={{margin:"auto", maxWidth: "300px", paddingTop:"2%", paddingLeft:"2%", paddingRight:"2%"}} >
                                        <p className="hc-f5 hc-f-l">{isFreeSite ? HC_LANG.INDEX_ABOUTSITE_LABEL : HC_LANG.INDEX_ABOUTSITE_LABEL_PNT}</p>
                                    </div>
                                </header>
                                <div id="loginbuttons" style={loginBtnStyle}>
                                    <button className="hc-button" onClick={this.handleLoginClicked}
                                            style={{marginBottom:"0.5em", minWidth: "108px"}}>{HC_LANG.INDEX_LOGIN_BUTTON}</button>
                                    {isFreeSite && <span className="hc-f5 hc-f-l" style={{margin: "1em"}}>{HC_LANG.OR}</span>}
                                    {isFreeSite && <button className="hc-button" onClick={this.handleSignupClicked}
                                            style={{marginTop:"0.5em", minWidth: "108px"}}>{HC_LANG.INDEX_SIGNUP_BUTTON}</button>}

                                </div>
                                <div style={{paddingTop:"1em", margin: "auto"}}>
                                    <section className="col-sm-4 hc-main-col"  style={{maxWidth: "230px", margin:"auto", verticalAlign: "top"}}>
                                        <p className="fa fa-copy hc-fa-big"/>
                                        <p className="hc-f5 hc-f-l"><b>{HC_LANG.INDEX_PAPERWORK_LABEL}</b><br />
                                            {isFreeSite ? HC_LANG.INDEX_PAPERWORK_LABEL_TEXT : HC_LANG.INDEX_PAPERWORK_LABEL_TEXT_PNT}</p>
                                    </section>
                                    <section className="col-sm-4 hc-main-col"  style={{maxWidth: "230px", margin:"auto", verticalAlign: "top"}}>
                                        <p className="fa fa-mobile-phone hc-fa-big"/>
                                        <p className="hc-f5 hc-f-l"><b>{HC_LANG.INDDEX_MOBILE_ACCESS_LABEL}</b><br />
                                            {isFreeSite ? HC_LANG.INDDEX_MOBILE_ACCESS_LABEL_TEXT : HC_LANG.INDDEX_MOBILE_ACCESS_LABEL_TEXT_PNT}</p>
                                    </section>
                                    <section className="col-sm-4 hc-main-col"  style={{maxWidth: "230px", margin:"auto", verticalAlign: "top"}}>
                                        <p className="fa fa-cloud hc-fa-big" />
                                        <p className="hc-f5 hc-f-l"><b>{HC_LANG.INDEX_ALWAYSACCESS_LABEL}</b><br />
                                            {HC_LANG.INDEX_ALWAYSACCESS_LABEL_TEXT}</p>
                                    </section>
                                </div>
                            </div>
                            <div style={{margin:"5%" }} onClick={this.resetData}>
                                {isFreeSite && <div
                                    className="hc-f4 hc-green hc-text-with-cursor"
                                    style={{marginBottom: "0.5rem"}}
                                    onClick={this.handleShowAboutUsClicked}>{HC_LANG.INDEX_ABOUT_US}
                                </div>}
                                {languagesItem}
                            </div>
                        </div>
                    )
                )}
            </div>)
    }
});


// WEBPACK FOOTER //
// ./index.js